import { selectIsOnline, setNetworkState } from "app/store/slices/network";
import { useNetworkState } from "expo-network";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSyncOfflineRequests } from "../../offline/hooks/useSyncOfflineRequests";

export function useNetworkStateListener() {
  const networkState = useNetworkState();
  const dispatch = useDispatch();
  const isOnline = useSelector(selectIsOnline);

  const hasMounted = useRef(false);

  const { syncOfflineRequests } = useSyncOfflineRequests();

  useEffect(() => {
    dispatch(setNetworkState(networkState));
  }, [networkState]);

  useEffect(() => {
    if (hasMounted.current && isOnline) {
      syncOfflineRequests();
    } else {
      hasMounted.current = true;
    }
  }, [isOnline]);

  return { networkState };
}
